var indentation_default = {
  "indentZero": "uZUeJ",
  "indentOne": "Stnzh",
  "indentTwo": "KH2jT",
  "indentThree": "je5Vx",
  "indentFour": "GKm9s",
  "indentFive": "Fo2rQ",
  "indentSix": "gzQc8"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
